import * as ActionTypes from './action.js';

export const INITIALIZE_STATE = {
    memberList:undefined,
    positionDetail: {}, // 任务进行到的位置
    titleDetail: {}, // 题目详情
    newImgList: [],
}

const reducerMap = {
    [ActionTypes.GET_MEMBER_LIST]: (state,payload) => {
        return Object.assign({}, state, {
           memberList:payload.memberList
        });
    },
    // 编辑参数
    [ActionTypes.EDIT_PARAM]: (state, payload) => {
        return Object.assign({}, state, payload);
    },
    // 任务进行到的位置
    [ActionTypes.CURRENT_QUESTION_PAGE]: (state, payload) => {
        return Object.assign({}, state, payload)
    },
    // 题目详情
    [ActionTypes.TITLE_DETAIL]: (state, payload) => {
        return Object.assign({}, state, payload)
    },
    [ActionTypes.TITLE_DETAIL_ERR]: (state, payload) => {
        return Object.assign({}, state, payload)
    },
    // 插画
    [ActionTypes.INSERT_PICTURE]: (state, payload) => {
        return Object.assign({}, state, {

        })
    },
    // 修改插画
    [ActionTypes.MODIFY_PICTURE]: (state, payload) => {
        return Object.assign({}, state, {

        })
    },
    // 插画审核通过
    [ActionTypes.PICTURE_PASS]: (state, payload) => {
        return Object.assign({}, state, {

        })
    },
    // 插画返工
    [ActionTypes.PUCTURE_REWORK]: (state, payload) => {
        return Object.assign({}, state, {

        })
    },
    // 标记修改
    [ActionTypes.SIGN_MODIFY]: (state, payload) => {
        return Object.assign({}, state, {

        })
    },
    // 标记返工
    [ActionTypes.SIGN_REWORK]: (state, payload) => {
        console.log(payload)
        return Object.assign({}, state, {})
    },
    // 标记通过
    [ActionTypes.SIGN_PASS]: (state, payload) => {
        return Object.assign({}, state, {

        })
    },
    // 标记题目
    [ActionTypes.SIGN_TITLE]: (state, payload) => {
        console.log(payload)
        return Object.assign({}, state, {

        })
    },
}


export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/reducer.js